Greenmile.Components = Greenmile.Components || {};

Greenmile.Components.AddAttribute = function (field, entitiesPropertiesList) {

    const fieldEl = field.rootEl;

    const updateBubblingMask = (textValue, parentClass) => {

        const bubblingMask = fieldEl.querySelector(`${parentClass} #bubbling-mask`);

        if (textValue) {

          const words   = textValue.split(' ');
          const regex   = /@([^\s]+)@/;
          let newHTML = '';

          for (let i = 0; i < words.length; i++) {

            if (regex.test(words[i])) {

              const  bubbleWord     = words[i].match(regex)[1];
              const  bubbleTag      = words[i].match(regex)[0];
              const  bubble         = document.createElement('span');
              const  leftAtSpan     = document.createElement('span');
              const  rightAtSpan    = document.createElement('span');
              const  tagIndex       = words[i].indexOf(bubbleTag);
              const  leftLeftOvers  = words[i].substring(0, tagIndex);
              const  rightLeftOvers = words[i].substring(leftLeftOvers.length + bubbleTag.length);

              leftAtSpan.className = 'bubbling-invisible-at';
              leftAtSpan.innerHTML = '@';

              rightAtSpan.className = 'bubbling-invisible-at';
              rightAtSpan.innerHTML = '@';

              bubble.className = 'bubbling-bubble';
              bubble.innerHTML = leftAtSpan.outerHTML + Monet.I18n.getResourcesByKey('SelectKeyResource.' + bubbleWord) + rightAtSpan.outerHTML;

              newHTML += `${leftLeftOvers}${bubble.outerHTML}${rightLeftOvers} `;

            } else {

              newHTML += `  ${words[i]}  `;

            }

          }

          bubblingMask.innerHTML = newHTML;

        } else {

          bubblingMask.innerHTML = "";

        }
    };

    const prepareAddAtribute = () => {
        const parentClass = `#${field.entity}_${field.name}`;
        const inputSelector = `[name="${field.name}"]`;

        const textArea = fieldEl.querySelector(`${parentClass} ${inputSelector}`);
        const bubblingUnit = fieldEl.querySelector(`${parentClass} #bubbling-mask`);
        const bubbleButton = fieldEl.querySelector(`${parentClass} #bubble-button`);
  
        const autoComplete = new Greenmile.Components.AddAttribute.AutoComplete(fieldEl);
        const selectFieldList = new Greenmile.Components.AddAttribute.SelectFieldList();
        
        selectFieldList.addClickEventListener((field) => {
            if(field) {
                textArea.value += ` ${field.value}`;
                updateBubblingMask(textArea.value, parentClass);
            }
        });
        selectFieldList.setAvailableTags(autoComplete.loadAvailableTags(entitiesPropertiesList));
        selectFieldList.render();
  
        bubbleButton.appendChild(selectFieldList.elFieldList);
        if(textArea.value) {
          updateBubblingMask(textArea.value, parentClass);
        }

        textArea.addEventListener('blur', () => {
          textArea.style.opacity = 0;
          textArea.style.zIndex = 0;
          bubblingUnit.style.opacity = 1;
          updateBubblingMask(textArea.value, parentClass);
        });
  
        textArea.addEventListener('focus', () => {
          bubblingUnit.style.opacity = 0;
          textArea.style.opacity = 1;
          textArea.style.zIndex = 999999;
          textArea.setSelectionRange(textArea.value.length, textArea.value.length);
        });
  
        bubblingUnit.addEventListener('click', () => {
          textArea.focus();
        });
      };

      const buildBubbleStructure = () => {
          const bubblingMask = document.createElement('div');
          const bubbleButton = document.createElement('div');
    
          bubblingMask.setAttribute('id', 'bubbling-mask');
          bubblingMask.setAttribute('class', `input-body_${field.name}`);
    
          bubbleButton.setAttribute('id', 'bubble-button');
    
          if(field.field.type === "TEXT") {
              fieldEl.querySelector('input').classList.add(`input-body_${field.name}`);
              fieldEl.querySelector('input').classList.add(`autocomplete_${field.name}`);
    
              fieldEl.appendChild(bubblingMask);
              fieldEl.appendChild(bubbleButton);
          } else if(field.field.type === "TEXT_AREA") {
            fieldEl.querySelector('textarea').classList.add(`input-body_${field.name}`);
            fieldEl.querySelector('textarea').classList.add(`autocomplete_${field.name}`);
  
            fieldEl.querySelector('div').appendChild(bubblingMask);
            fieldEl.querySelector('div').appendChild(bubbleButton);
          }

      };

      this.render = () => {
        if(!fieldEl) {
            console.error('No field provided');
            return;
        }
        buildBubbleStructure();
        prepareAddAtribute();
      };

    return this;
};